// extracted by mini-css-extract-plugin
export default {"departments":"ZG-z","departmentHeading":"_G-z","departmentSection":"aH-z","departmentName":"bH-z","departmentLink":"cH-z","expandIcon":"dH-z"};